export interface TimeEntry {
	capital: boolean;
	customerServiceDesc: string;
	customerServiceId: number;
	id: number;
	minutes: number;
	note: string;
	payCodeDesc: string;
	payCodeId: number;
	time: string; // ISO Timestamp
	timeCodeDesc: string;
	timeCodeId: number;
}

export class TimeEntryAddHttp {
	techId: number;
	apptId: number;
	time: string;
	timeCodeId: number;
	minutes: number;
	capital: boolean;
	payCodeId: number;
	customerServiceId: number;
	note: string;

	constructor(techId: number, apptId: number, entry: TimeEntry) {
		this.techId = techId;
		this.apptId = apptId;
		this.time = entry.time;
		this.timeCodeId = entry.timeCodeId;
		this.minutes = entry.minutes;
		this.capital = entry.capital;
		this.payCodeId = entry.payCodeId;
		this.customerServiceId = entry.customerServiceId;
		this.note = entry.note;
	}

}

export class TimeEntryEditByIdHttp {
	id: number;
	customerServiceId: number;
	timeCodeId: number;
	payCodeId: number;
	minutes: number;
	capital: boolean;
	note: string;

	constructor(entry: TimeEntry) {
		this.id = entry.id;
		this.customerServiceId = entry.customerServiceId;
		this.timeCodeId = entry.timeCodeId;
		this.payCodeId = entry.payCodeId;
		this.minutes = entry.minutes;
		this.capital = entry.capital;
		this.note = entry.note;
	}
}

export class TimeEntryEditByInfoHttp {
	techId: number;
	apptId: number;
	time: string;
	timeCodeId: number;
	minutes: number;
	capital: boolean;
	payCodeId: number;
	customerServiceId: number;
	note: string;

	constructor(techId: number, apptId: number, entry: TimeEntry) {
		this.techId = techId;
		this.apptId = apptId;
		this.time = entry.time;
		this.timeCodeId = entry.timeCodeId;
		this.minutes = entry.minutes;
		this.capital = entry.capital;
		this.payCodeId = entry.payCodeId;
		this.customerServiceId = entry.customerServiceId;
		this.note = entry.note;
	}

}
